import { useEffect, useState } from "react";
import { useStateValue } from "./StateProvider";

export default function useMousePosition() {
    const [mousePosition, setMousePosition] = useState({ x: null, y: null });
    const [{ x, y }, dispatch] = useStateValue();


    useEffect(() => {
        const mouseMoveHandler = (event) => {
            const { clientX, clientY } = event;
            setMousePosition({ x: clientX, y: clientY });
            dispatch({
                type: "SET_XY",
                x: clientX,
                y: clientY
            });
        };
        document.addEventListener("mousemove", mouseMoveHandler);

        return () => {
            document.removeEventListener("mousemove", mouseMoveHandler);
        };
    }, []);

    return mousePosition;
}
